import { Injectable } from '@angular/core';
import { AgStripeSubtotalKeys, StripeTransaction, StripeTransactionKeys } from 'ag-common-lib/public-api';
import { BaseFormService } from '../../utils/base-form-service';

@Injectable()
export class AttendeeTransactionModalService extends BaseFormService<StripeTransaction> {
  constructor() {
    super();
  }

  getFormData = (stripeTransaction?: Partial<StripeTransaction>) => {
    this.formData = new Proxy(Object.assign({}, new StripeTransaction(), stripeTransaction), {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];
        this.formChangesDetector.handleChange(prop, value, prevValue);
        Reflect.set(target, prop, value, receiver);
        switch (prop) {
          case StripeTransactionKeys.details:
            const totalAmount = value.reduce((sum, obj) => sum + Number(obj[AgStripeSubtotalKeys.amount]), 0);

            Object.assign(this.formData, { [StripeTransactionKeys.amount]: totalAmount });
            break;
        }
        return true;
      },
    });
    return this.formData;
  };
}
